import { useParams } from 'react-router';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Header, MarginPosition, Redirect, StyledFlex } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { PatientGroups } from '~libs.desktop.shared.patient-groups';
import { patientPaths } from '~libs.desktop.shared.paths';

import { PatientActionBar } from '../common/PatientActionBar';
import { PatientFormLoader } from '../common/PatientForm.loader';

import { MedicalDocumentationCreateAction } from './MedicalDocumentationCreate/actions/MedicalDocumentationCreateAction';
import { PatientConfirmedUpdatePanelNavTabs } from './PatientConfirmedUpdatePanelNavTabs';
import { StyledPatientConfirmedUpdatePanel } from './PatientConfirmedUpdatePanel.styled';

type PatientConfirmedUpdatePanelParams = {
   patientId?: string;
};

type PatientConfirmedUpdatePanelRendererProps = {
   readonly patient: Patient;
};

const PatientConfirmedUpdatePanelRenderer = (props: PatientConfirmedUpdatePanelRendererProps): JSX.Element => {
   return (
      <PatientActionBar>
         <StyledPatientConfirmedUpdatePanel>
            <StyledFlex gap={'8px'} alignItems={'center'}>
               <Header testId={'name'} margin={MarginPosition.NONE}>
                  {createTranslatedText(`${props.patient.firstName ?? ''} ${props.patient.lastName ?? ''}`)}
               </Header>
               <PatientGroups patientGroups={props.patient.patientGroups} />
            </StyledFlex>
            <PatientConfirmedUpdatePanelNavTabs patient={props.patient} />
         </StyledPatientConfirmedUpdatePanel>
         {protectFeature('searchingMedicalData', <MedicalDocumentationCreateAction patientId={props.patient.id} />)}
      </PatientActionBar>
   );
};

export const PatientConfirmedUpdatePanel = (): JSX.Element => {
   const params = useParams<PatientConfirmedUpdatePanelParams>();
   return (
      <PatientFormLoader patientId={params.patientId}>
         {({ patient }) => {
            if (!patient.referenceIdentifier) {
               return <Redirect path={patientPaths.getTemporaryDataPath(patient.id)} />;
            }

            return <PatientConfirmedUpdatePanelRenderer patient={patient} />;
         }}
      </PatientFormLoader>
   );
};
